/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Loader } from "../ui/loader";

export const CircularProgressWithLabel = (props) => {
  const { theme, value = 0, size = 200 } = props;
  
  // Theme-based color or fallback to primary
  const loaderColor = theme?.defaultUserTheme?.primaryTextColor ? 'primary' : 'primary';
  
  return (
    <div 
      className="relative inline-flex items-center justify-center"
      style={{ 
        marginTop: "100px",
        width: size,
        height: size 
      }}
    >
      {/* Use the existing Loader component */}
      <Loader 
        variant="ring" 
        size="xl" 
        color={loaderColor}
        className="absolute"
        style={{
          color: theme?.defaultUserTheme?.primaryTextColor
        }}
      />
      
      {/* Center content with progress percentage */}
      <div className="absolute flex items-center justify-center text-center">
        <div className="text-sms whitespace-pre-line">
          {`${Math.round(value)}% \n\nDownloading PDF file...`}
        </div>
      </div>
    </div>
  );
};
